/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

export * from "./CosmosPageHeroAndSections.data";
export * from "./CosmosPageHeroAndSections.page";
